/**
 * 회원 전화번호 마스킹 (MB_EVENT_007 - 전화번호 숨김처리)
 *
 * 이 권한은 다른 권한과 방향이 반대다. ON 이면 "허용"이 아니라 "마스킹"이다.
 * 권한이 꺼져 있으면(기본값) 지금까지와 동일하게 전체가 노출된다.
 *
 * 화면 표시만 가린다. 서버는 여전히 원문을 내려주므로 개발자도구로는 확인할 수 있다.
 */
import store from '@/store';

export const CUSTOMER_PHONE_MASK_EVENT_CD = 'MB_EVENT_007';

/**
 * 회원 전화번호를 가려야 하는지.
 *
 * 권한 코드는 store 에서 읽는다. 반응형이라 권한 로딩이 끝나면 화면이 다시 그려진다.
 * localStorage 를 직접 읽으면 반응형이 아니어서, 목록이 먼저 그려진 화면은 권한이
 * 도착해도 그대로 남는다.
 *
 * 아직 로드되지 않았거나(null) 조회에 실패한 상태는 가린 채로 둔다(fail-closed).
 * 로그인 시 저장된 권한 코드가 지워지므로, 열어두면 로그인 직후 목록이 원문으로
 * 한 번 그려진다. 권한이 꺼진 사용자에게는 잠깐 가려졌다가 풀리는 것으로 보인다.
 */
export function isCustomerPhoneMasked() {
    const eventCds = store.state.auth.menuEventCds;

    if (!Array.isArray(eventCds)) {
        return true;
    }

    return eventCds.indexOf(CUSTOMER_PHONE_MASK_EVENT_CD) >= 0;
}

/**
 * 전화번호의 중간자리를 가린다. 입력 형식은 그대로 둔다.
 *   010-6462-2655 -> 010-****-2655
 *   01064622655   -> 010****2655
 * 형식을 판별하지 못하면 뒤 4자리만 남기고 모두 가린다. 판별 못 한 값이 그대로 노출되면 안 된다.
 */
export function maskPhoneNumber(formattedPhone) {
    if (!formattedPhone) return formattedPhone;

    const text = String(formattedPhone);
    const parts = text.split('-');

    if (parts.length === 3) {
        return `${parts[0]}-${'*'.repeat(parts[1].length)}-${parts[2]}`;
    }

    const digits = text.replace(/[^0-9]/g, '');
    if (digits.length <= 4) return text;

    // 하이픈 없는 원문. 국번 자리만 가려 원래 형식을 유지한다
    if (digits === text && digits.length >= 9) {
        const head = digits.indexOf('02') === 0 ? 2 : 3;
        return digits.slice(0, head) + '*'.repeat(digits.length - head - 4) + digits.slice(-4);
    }

    return `${'*'.repeat(digits.length - 4)}-${digits.slice(-4)}`;
}

/**
 * 컴포넌트에서 같은 판정을 쓰기 위한 믹스인.
 *
 * mixinAllowedMenu 의 isAllowed('MB', 7) 를 쓰면 안 된다. 그쪽은 권한이 로드되기 전이나
 * 조회에 실패했을 때 false 를 돌려주는데, 이 권한은 방향이 반대라 그 값이 "가리지 않음"이
 * 되어 원문이 노출된다.
 */
export const MixinCustomerPhoneMask = {
    methods: {
        isCustomerPhoneMasked,
        maskCustomerPhone,
    },
};

// 권한이 켜져 있을 때만 마스킹한다. 표시 직전에 한 번만 통과시키면 된다.
export function maskCustomerPhone(formattedPhone) {
    if (!formattedPhone) return formattedPhone;
    if (!isCustomerPhoneMasked()) return formattedPhone;

    return maskPhoneNumber(formattedPhone);
}
